"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Helper mixin for using styled elements with dynamic styles.
// for Example <Div styles={STYLES_OBJECT} />
// will apply all styles STYLES_OBJECT to styled element in runtime
var stylesProcessor = function stylesProcessor(props) {
  return props.styles;
};

var extendTaggedTemplate = function extendTaggedTemplate(constructor) {
  return function (strings) {
    var newStrings = (0, _toConsumableArray2["default"])(strings);
    newStrings.push('\n');
    newStrings.raw = (0, _toConsumableArray2["default"])(strings.raw);
    newStrings.raw.push('\n');

    for (var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      expressions[_key - 1] = arguments[_key];
    }

    expressions.push(stylesProcessor);
    return constructor.apply(void 0, [newStrings].concat(expressions));
  };
};

var createStyledTag = function createStyledTag(tag, attrs) {
  if (attrs) {
    return extendTaggedTemplate(tag.attrs(attrs));
  } else {
    return extendTaggedTemplate(tag);
  }
}; // Surrogate with styled API


var customStyled = function customStyled(tag) {
  var proxyStyled = createStyledTag(tag);

  proxyStyled.attrs = function () {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return createStyledTag(tag, attrs);
  };

  return proxyStyled;
}; // Proxy styled property for saving native syntax


var styledProxy = new Proxy(_styledComponents["default"], {
  get: function get(target, prop) {
    return customStyled(target[prop]);
  }
});
var _default = styledProxy;
/*
    example: {
        "Div": styled.div``,
    }
*/

exports["default"] = _default;
var cachedElements = {};
var Styled = new Proxy(styledProxy, {
  get: function get(target, prop) {
    var element = null;

    if (prop && typeof prop.toLowerCase === 'function') {
      var key = prop.toLowerCase();

      if (!cachedElements[key]) {
        cachedElements[key] = target[key](_templateObject());
      }

      element = cachedElements[key];
    }

    return element;
  }
});
exports.Styled = Styled;